import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordPage } from "@/features/auth";

/** Public. Asking for a link needs nothing but an email address. */
export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
});
